module.exports = __webpack_public_path__ + "static/media/comment-dots.d00076e3.svg";